import { VccCredentialsListItem } from '../../../integrated-client/models/';

interface ITableData {
  records: Array<VccCredentialsListItem>;
  totalItems?: number;
}

export class TableData implements ITableData {
  records: Array<VccCredentialsListItem>;
  totalItems?: number;

  constructor() {
    this.records = [];
  }
}
